<template>
    <footer class="footer has-cards">
      <div class="container">
        <!-- <div class="row align-items-start justify-content-start"> -->
            <div class="copyright">
                &copy; {{year}}
                <a href="https://www.teach4taiwan.org/" target="_blank" rel="noopener">Teach for Taiwan</a>
            </div>
        <!-- </div> -->
      </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
